/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   pin click event thunk
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { MAP_LIST_ALERT, event } from '@zcode-ui/web-zumper-integrations'
import type { Origin } from '@zcode/nr-utils'
import type { Filters, GetState, SaveSearchModal, SimilarFilters } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import type { Dispatch } from 'redux'
import { getCurrentLocation } from '../../../inspectors/index'
import { selectFilters } from '../../filters/selectors/index'

interface TrackAlertEventProps {
  filters: MaybeEmpty<Filters> | SimilarFilters | undefined
  name: 'DETAIL_ALERT' | undefined
  origin: Origin | SaveSearchModal['origin']
}

export const trackAlertEvent =
  ({ filters, origin, name }: TrackAlertEventProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()

    const user = getUser(state)
    const reduxStateFilters = selectFilters(state)
    const location = getCurrentLocation(state)

    const props = {
      alertFilters: filters,
      origin,
    }
    dispatch(
      event({ name: name ?? MAP_LIST_ALERT, props, user, filters: reduxStateFilters, location })
    )
  }
